import Button from 'features/layout/components/Button';

import documentIcon from '../../../styles/images/document-icon.svg';
import downloadBtn from '../../../styles/images/download-icon.svg';
import pdfIcon from '../../../styles/images/pdf-icon.svg';
import cross from '../styles/images/Cross-X.svg';
import eye from '../styles/images/Eye.svg';

import '../styles/drag-and-drop.scss';

type Document = {
  documentUid?: string;
  templateUid?: string;
  issueDate?: string;
  lastUpdated?: string | null;
  expiryDate?: string;
  documentType?: {
    id: string;
    name: string;
  };
  filename?: string;
};

type DocumentPreviewProps = {
  file?: Document;
  isPDF?: boolean;
  handleDownload?: (uid?: string, fileName?: string) => void;
  handleOpen?: (uid?: string) => void;
  handleDelete?: (uid?: string) => void;
  hideOpen?: boolean;
  hideDownload?: boolean;
  isDisabled?: boolean;
};

const DocumentPreview = ({
  file,
  isPDF = false,
  handleDownload = () => {},
  handleOpen = () => {},
  handleDelete = () => {},
  hideOpen = false,
  hideDownload = true,
  isDisabled = false,
}: DocumentPreviewProps) => {
  const formattedDate = (date: string) => {
    if (!date) return '';
    const options: any = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString('en-GB', options);
  };

  return file ? (
    <li className="drag-and-drop_file_card">
      <div className="drag-and-drop_file_card_content">
        <div className="drag-and-drop_file_card_content_title">
          <img
            className={`drag-and-drop_file_card_content_title_icon ${isDisabled ? 'disabled' : ''}`}
            src={isPDF ? pdfIcon : documentIcon}
            alt="document-icon"
          />
          <div
            className={`drag-and-drop_file_card_content_title_text ${isDisabled ? 'disabled' : ''}`}>
            <span
              className={`drag-and-drop_file_card_content_title_text__title ${isDisabled ? 'disabled' : ''}`}>
              {file.filename}
            </span>
            <span
              className={`drag-and-drop_file_card_content_title_text__subtitle ${isDisabled ? 'disabled' : ''}`}>
              Last Updated: {formattedDate(file.lastUpdated ?? '')}
            </span>
          </div>
        </div>
        <div className="drag-and-drop_file_card_content_btns">
          {hideOpen ? null : (
            <Button
              className="drag-and-drop_file_card_content_btns__open light"
              iconMiddle={eye}
              type="button"
              onClick={() => handleOpen(file.documentUid)}>
              Open
            </Button>
          )}
          {hideDownload ? null : (
            <Button
              className="drag-and-drop_file_card_content_btns__open light"
              iconMiddle={downloadBtn}
              type="button"
              onClick={() => handleDownload(file.documentUid, file.filename)}
            />
          )}
          <Button
            className={`drag-and-drop_file_card_content_btns__cross ${isDisabled ? 'disabled' : ''}`}
            iconMiddle={cross}
            onClick={() => handleDelete(file.documentUid)}
          />
        </div>
      </div>
    </li>
  ) : null;
};

export default DocumentPreview;
